<template>
  <div class="row sim-type-data">
      <b-col md="" sm="12" class="label">
        <slot name="lblSimType">SIM Typ: </slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{simType === SimTypes.simCardCode ? SimTypes.simCardLabel : SimTypes.eSimLabel }}</b-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCol } from 'bootstrap-vue'
import { SimTypes } from '@/helper/SimTypes'

export default {
  name: 'SimTypeSummary',
  components: { BCol },
  data () {
    return {
      SimTypes
    }
  },
  computed: {
    ...mapGetters('activation/personalData', [
      'simType'
    ])
  }
}
</script>
